<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-05 17:32:40
 * @LastEditTime: 2019-08-18 20:13:27
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div>
    <el-form ref="form1" :model="form1" label-width="120px" :inline="true">
      <el-form-item label="关键词:">
        <el-input
          v-model="form1.keywords"
          clearable
          placeholder="核销单号，产品名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="核销时间:" style="text-align: center">
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="开始时间"
            v-model="form1.start_time"
            style="width: 100%"
          ></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">-</el-col>
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="结束时间"
            v-model="form1.end_time"
            style="width: 100%"
          ></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch()">搜索</el-button>
        <el-button type="primary" @click="onExport()">导出</el-button>
      </el-form-item>
    </el-form>
    <div>核销总数:{{ total }}</div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      v-loading="loading"
      border
      stripe
      style="width: 97.5%; margin: 20px"
    >
      <el-table-column
        prop="out_trade_no"
        label="核销单号"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="product_image" label="礼品图片" width="100">
        <template slot-scope="scope">
          <div>
            <img :src="scope.row.product_image" height="50" width="50" alt="" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="product_number" label="礼品编号" width="120">
      </el-table-column>
      <el-table-column
        prop="product_name"
        label="礼品名称"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="code_key"
        label="核销码"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="create_time"
        label="核销时间"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="number"
        label="核销数量"
        show-overflow-tooltip
        width="80"
      ></el-table-column>
    </el-table>
    <el-pagination
      style="margin: 20px 0"
      @size-change="handleSizeChange2"
      @current-change="handleCurrentChange2"
      :current-page="pageNo"
      :page-sizes="[5, 10, 20, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalSize"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "verify",
  data() {
    return {
      form1: {
        start_time: "",
        end_time: "",
        keywords: "",
      },
      tableData: [],
      total: 0,
      pageNo: 1,
      pageSize: 20,
      totalSize: 0,
      detailData: {},
    };
  },
  methods: {
    getLastMonth() {
      var now = new Date();
      var year = now.getFullYear(); //getYear()+1900=getFullYear()
      var month = now.getMonth() + 1; //0-11表示1-12月
      var day = now.getDate();
      var dateObj = {};
      if (parseInt(month) < 10) {
        month = "0" + month;
      }
      if (parseInt(day) < 10) {
        day = "0" + day;
      }

      dateObj.now = year + "-" + month + "-" + day;

      if (parseInt(month) == 1) {
        //如果是1月份，则取上一年的12月份
        dateObj.last = parseInt(year) - 1 + "-12-" + day;
        return dateObj;
      }

      var preSize = new Date(year, parseInt(month) - 1, 0).getDate(); //上月总天数
      if (preSize < parseInt(day)) {
        //上月总天数<本月日期，比如3月的30日，在2月中没有30
        dateObj.last = year + "-" + month + "-01";
        return dateObj;
      }

      if (parseInt(month) <= 10) {
        dateObj.last = year + "-0" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      } else {
        dateObj.last = year + "-" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      }
    },
    onSearch() {
      this.loading = true;
      if (this.form1.start_time) {
        this.form1.start_time = this.moment(this.form1.start_time).format("YYYY-MM-DD");
      }
      if (this.form1.end_time) {
        this.form1.end_time = this.moment(this.form1.end_time).format("YYYY-MM-DD");
      }
      this.$get("logistics_2", "/vstore/dealer_pc/lowerDealerStoreVerifyList", {
        ...this.form1,
        per_page: this.pageSize,
        page: this.pageNo,
        store_sn: this.$route.query.store_sn,
      })
        .then((res) => {
          this.loading = false;
          this.tableData = res.data.data;
          this.totalSize = res.data.total;
          this.total = res.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onExport() {
      let access_tokens = localStorage.getItem("access_token");
      window.open(
        this.apis.logistics_2 +
          "vstore/dealer_pc/lowerDealerStoreVerifyList?" +
          "lang=" +
          "" +
          "&is_export=1" +
          "&start_time=" +
          this.form1.start_time +
          "&end_time=" +
          this.form1.end_time +
          "&keywords=" +
          this.form1.keywords +
          "&store_sn=" +
          this.$route.query.store_sn +
          "&signature=Bearer " +
          access_tokens
      );
    },
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.pageNo2 = 1;
      this.onSearch();
    },
    handleCurrentChange2(val) {
      this.pageNo2 = val;
      this.onSearch();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.getDetail();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getDetail();
    },
  },
  created() {
    this.form1.start_time = this.getLastMonth().last;
    this.form1.end_time = this.getLastMonth().now;
    this.onSearch();
  },
};
</script>
